import React, { useLayoutEffect, useRef, memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'ui-components/components/button';
import { BatchSinglePropType } from '../../../prop-types/batch-single';
import { noop } from 'ui-components/default-props/noop';
import { useLocation } from 'react-router-dom';
import { TruncatedText } from 'ui-components/components/truncated-text';
import style from './batch-list-item.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

const BatchListItem = ({
  batch = emptyObject,
  onClick = noop,
  disabled = false,
  isSelectedBatch = false,
  selected = false,
  className = '',
  isNavItem = false,
  shouldHighlight = false,
}) => {
  const containerRef = useRef(null);
  const isFirstRender = useRef(true);
  const { name, shipmentCount } = batch;
  const { pathname } = useLocation();
  const { fulfillmentPlanSetId } = batch;
  const pathIncludesFulfillmentPlanSetId = pathname.includes(`batches/open/${fulfillmentPlanSetId}`);

  useLayoutEffect(() => {
    if ((isNavItem && !isFirstRender.current) || shouldHighlight) {
      const { classList } = containerRef.current;
      if (!classList.contains(style.animate) && !classList.contains(style['duplicate-rule'])) {
        classList.add(style.animate);
        return;
      }
      if (classList.contains(style.animate)) {
        classList.replace(style.animate, style['duplicate-rule']);
        return;
      }
      classList.replace(style['duplicate-rule'], style.animate);
      return;
    }
    isFirstRender.current = false;
  }, [shipmentCount, isNavItem, isFirstRender, shouldHighlight]);

  const classNames = classnames(style['batch-list-item'], className, {
    [style.selected]: selected,
    [style['nav-item']]: isNavItem,
    [style['show-arrow-indicator']]: pathIncludesFulfillmentPlanSetId,
  });

  return (
    <div ref={containerRef} className={style['batch-item-wrapper']}>
      <Button className={classNames} disabled={disabled} onClick={onClick} theme='unstyled'>
        <div className={style['name-and-date']}>
          <div
            className={classnames(style.name, className, {
              [style.isSelectedBatch]: isSelectedBatch,
            })}
          >
            <TruncatedText value={name} />
          </div>
        </div>
        <div
          className={classnames(style.count, className, {
            [style.isSelectedBatch]: isSelectedBatch,
          })}
        >
          {shipmentCount}
        </div>
      </Button>
    </div>
  );
};

BatchListItem.propTypes = {
  batch: BatchSinglePropType,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  shouldHighlight: PropTypes.bool,
  isNavItem: PropTypes.bool,
  className: PropTypes.string,
  isSelectedBatch: PropTypes.bool,
};

export default memo(BatchListItem);
